export enum ElementStatus{
  DRAFT = "DRAFT",
  IN_REVIEW = "IN_REVIEW",
  READY = "READY",
  OBSOLETE = "OBSOLETE",
  REWORK = "REWORK"
}
